<div class="cpcontent">
    <h2>Environmet Variables</h2>
    Production: {{env.production}}<br>
    file: {{env.file}}<br>
    backendapi: {{env.backendapi}}<br>
    dbSource used by the backend: {{dbenv.dbSource}}<br>
    dbName used by the backend: {{dbenv.dbName}}<br>
    <br>

    <h3>Angular Client</h3>
    In Angular you can specify environment variables in the files:<br>
    <ul>
        <li><b>environments -> environment.ts</b>: Local</li>
        <li><b>environments -> environment.dev.ts</b>: Development</li>
        <li><b>environments -> environment.prod.ts</b>: Production</li>
    </ul>
    These files contain environment variables like keys.
    <br>
    During the build and serve phase you can determine which file to use:
    <ul>
        <li><b>ng serve</b>: uses the local environment: "environment.ts"</li>
        <li><b>ng serve --configuration= development</b>: use the development environment: "environment.dev.ts"</li>
        <li><b>ng serve --configuration= production</b>: use the production environment: "environment.prod.ts"</li>
    </ul>
    <br>

    <h3>.Net Back End</h3>
    The database strings are defined by the connection string in appsetting.json.
    This is set manually on server.<br>
    <b>The compiled code is uploaded to the server without these files.</b>


</div>
